import gql from 'graphql-tag';

export const PrintAssetDetails = gql`
  fragment PrintAssetDetails on PrintAsset {
    id
    name
    type
    source
    asset_image {
      id
      url
    }
    preview_asset_image {
      id
      url
    }
    photo_pricing_categories {
      total
      records {
        id
        photo_pricing_category {
          id
          name
        }
      }
    }
    print_package_categories {
      total
      records {
        id
        print_package_category {
          id
          name
        }
      }
    }
    pricing_categories {
      total
      records {
        id
        pricing_category {
          id
          name
        }
      }
    }
    jersey_colors {
      total
      records {
        id
        jersey_color
      }
    }
    print_sizes(slice: { limit: 999 }) {
      total
      records {
        id
        print_size {
          id
          name
          width
          height
        }
        asset_image {
          id
          url
        }
      }
    }
  }
`;
